require('!script-loader!./Scriptaculous/scriptaculous.js')
require('!script-loader!./Scriptaculous/effects-minified.js')

require('./Legacy/fancy-glide.js')
require('./Legacy/panels.js')
require('!script-loader!./Legacy/Tabs/tabs.js')

require('./foundation.js')
